<template>
  <hr class="divider" />
</template>

<style scoped lang="scss">
.divider {
  margin: 24px 0;
  border: none;
  border-top: 1px solid var(--alias-color-border-default, rgb(0 0 0 / 10%));
}
</style>
